import {containsSubdomain} from "../utils";

export const PRODUCT_SELECTOR = {
    URL: containsSubdomain('review') || process.env.NODE_ENV === 'development' ? 'https://review.masterlock.com/product/selector/safe' : 'https://www.masterlock.com/product/selector/safe',
    TEXT: 'Product Selector',
    TARGET: '_blank'
}


// WEBPACK FOOTER //
// ./src/constants/app.js